//Librairies
import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { allReducers } from './stores/index';
import { GetAuthProvider } from './authentication/authProvider';
import { connect } from 'react-redux';
//css
import './styles/App.scss';
import 'notyf/notyf.min.css';

//prechargement
import iconclose from './assets/icon-close.svg';
import iconclosehover from './assets/icon-close_survol.svg';
import iconedit from './assets/edit.svg';
import iconbin from './assets/bin.svg';

const loading = () => <div className="animated fadeIn pt-3 text-center"><div className="sk-spinner sk-spinner-pulse"></div></div>;

// Containers
const SaurLayout = React.lazy(() => import('./components/SaurLayout/SaurLayout'));

class App extends Component {
  render() {
    return (<>
      {/* prechargement des icones pour éviter l'effet clipping....  la div est caché pour ne pas être visible*/}
      <div id="preload" className="d-none">
        <img src={iconclose} alt="preloadicone" />
        <img src={iconclosehover} alt="preloadicone" />
        <img src={iconedit} alt="preloadicone" />
        <img src={iconbin} alt="preloadicone" />
      </div>
      <AzureAD provider={GetAuthProvider()} reduxStore={allReducers} forceLogin={true}>
        {({ accountInfo, authenticationState, error }) => {
          return (
            <React.Fragment>
              {authenticationState === AuthenticationState.Authenticated && (
                <HashRouter>
                  <React.Suspense fallback={loading()}>
                    <Switch>
                      <Route path="/" name="Home" render={props => <SaurLayout {...props} />} />
                    </Switch>
                  </React.Suspense>
                </HashRouter>
              )}
            </React.Fragment>
          )
        }}
      </AzureAD></>);
  }
}


export default connect(state => state)(App);

